import { render, staticRenderFns } from "./dialogListAnswer.vue?vue&type=template&id=aed8fc82&"
import script from "./dialogListAnswer.vue?vue&type=script&lang=js&"
export * from "./dialogListAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports